import toast from 'react-hot-toast';
import Modal from 'react-bootstrap/Modal';

import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { toastErrorFromResponse } from '../../util/utilitarios';

import TituloSessao from '../../componentes/TituloSessao';
import { formataDate } from '../../util/datas';

import { limiteCaracteres } from '../../config/limiteCaracteres';
import { servAssinaturaFinal, servGetAllOpcaoRespostaFormularioAcompanhamento, servGetFormularioAcompanhamento, servRetificaRelatorioAcompanhamento } from '../../servicos/servicosEmRotasPrivadas/formulario_acompanhamento';

function VerificaRelatorio() {

    console.log('### Iniciando Verifica de Relatório ###')

    const navigate = useNavigate();
    const { relatorioAcompanhamentoId } = useParams();

    const [showModalAssinatura, setShowModalAssinatura] = useState(false);
    const [modoRetificacao, setModoRetificacao] = useState(false);

    const [relatorioAcompanhamento, setRelatorioAcompanhamento] = useState(null)
    const [opcoesRespostas, setOpcoesRespostas] = useState(null)
    const [assinatura, setAssinatura] = useState({
        nomeCompleto: null,
        matricula: null,
        setor: null
    })

    useEffect(() => {

        const getFormularioAcompanhamento = async () => {

            try {
                const relatorioDaApi = await toast.promise(
                    servGetFormularioAcompanhamento(relatorioAcompanhamentoId),
                    { loading: 'Buscando Relatório de Acompanhamento...' }
                )
                setRelatorioAcompanhamento(relatorioDaApi.data)
            } catch (error) {
                toastErrorFromResponse(error);
            }

        };

        const getAllOpcaoRespostaFormularioAcompanhamento = async () => {
            try {
                const respostasDaApi = await servGetAllOpcaoRespostaFormularioAcompanhamento()
                const idNaoSeAplica = respostasDaApi.data.find(resposta => resposta.resposta.includes('N.A'))?.id;
                setOpcoesRespostas({
                    respostas: respostasDaApi.data,
                    idNaoSeAplica: idNaoSeAplica
                })
            } catch (erro) {
                toast.error(erro.message)
                console.error(erro);
            }
        }

        getAllOpcaoRespostaFormularioAcompanhamento()
        getFormularioAcompanhamento();

    }, []);

    function onChangeAssinatura(campo, valor) {
        setAssinatura(prevState => ({
            ...prevState,
            [campo]: valor
        }));
    }

    async function retificaRelatorioAcompanhamento() {

        const retificacaoObj = {
            relatorioAcompanhamentoId,
            itens: relatorioAcompanhamento.itensFormulario.flatMap(bloco =>
                bloco.itens.map(item => ({
                    modeloItemFormularioAcompanhamentoId: item.modeloItemId,
                    observacao: item.obs,
                    respostaId: item.respostaId
                }))
            )
        };

        try {
            const response = await toast.promise(
                servRetificaRelatorioAcompanhamento(retificacaoObj),
                { loading: 'Retificando relatório...' }
            );
            toast.success(response.data.message);
            navigate(-1);
        } catch (error) {
            toastErrorFromResponse(error);
        }
    }

    async function assinaturaFinal() {

        const reqBodyAssinaturaFinal = {
            assinatura: assinatura,
            formularioAcompanhamentoId: relatorioAcompanhamento.formularioId
        }

        if (
            !reqBodyAssinaturaFinal.assinatura.nomeCompleto ||
            !reqBodyAssinaturaFinal.assinatura.matricula ||
            !reqBodyAssinaturaFinal.assinatura.setor
        ) {
            toast.error('Por favor, informe os dados da assinatura do aprovador');
            return;
        }

        try {
            const response = await toast.promise(
                servAssinaturaFinal(reqBodyAssinaturaFinal),
                { loading: 'Assinando relatório...' }
            );
            toast.success(response.data.message);
            navigate(-1);
        } catch (error) {
            toastErrorFromResponse(error);
        }
    }

    function handleChangeItem(itemId, field, value) {

        if (field === 'respostaId') value = parseInt(value, 10);
        if (field === 'obs') {
            if (!value) value = null
        }

        setRelatorioAcompanhamento((prev) => ({
            ...prev,
            itensFormulario: prev.itensFormulario.map((bloco) => ({
                ...bloco,
                itens: bloco.itens.map((item) =>
                    item.itemId === itemId
                        ? {
                            ...item,
                            [field]: value
                        }
                        : item
                ),
            })),
        }));
    }

    return (
        <div className='container-fluid d-flex flex-column gap-3 p-3'>

            <Modal show={showModalAssinatura} onHide={() => setShowModalAssinatura(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Assinatura Final</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Informe os dados da <strong>Assinatura Final</strong>.</p>
                    <div className='d-flex flex-column gap-3'>
                        <div className="">
                            <label htmlFor="nome-completo" className="form-label">Nome Completo</label>
                            <input
                                type="text"
                                className="form-control"
                                id="nome-completo"
                                onChange={(e) => onChangeAssinatura('nomeCompleto', e.target.value)}
                                maxLength={limiteCaracteres.RELAT_ACOMP_ASSINATURA}
                                required
                            />
                        </div>
                        <div className="">
                            <label htmlFor="matricula" className="form-label">Matrícula</label>
                            <input
                                type="text"
                                className="form-control"
                                id="matricula"
                                onChange={(e) => onChangeAssinatura('matricula', e.target.value)}
                                maxLength={limiteCaracteres.RELAT_ACOMP_ASSINATURA}
                                required
                            />
                        </div>
                        <div className="">
                            <label htmlFor="setor" className="form-label">Setor</label>
                            <input
                                type="text"
                                className="form-control"
                                id="setor"
                                onChange={(e) => onChangeAssinatura('setor', e.target.value)}
                                maxLength={limiteCaracteres.RELAT_ACOMP_ASSINATURA}
                                required
                            />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className="btn btn-secondary"
                        onClick={() => setShowModalAssinatura(false)}
                    >
                        CANCELAR
                    </button>
                    <button
                        className="btn btn-primary"
                        onClick={assinaturaFinal}
                    >
                        ASSINAR
                    </button>
                </Modal.Footer>
            </Modal>

            <TituloSessao
                titulo='Verificação de Relatório de Acompanhamento'
                barraDecorativa={false}
            />

            <div className='container-fluid'>
                {relatorioAcompanhamento &&
                    <div>

                        <div className='div-com-borda container justify-content-around d-flex gap-3 p-3'>
                            <div className='d-flex flex-column gap-3'>
                                <p className='m-0'><strong>Unidade:</strong> {relatorioAcompanhamento.estabelecimento}</p>
                                <p className='m-0'><strong>Mês Referência:</strong> {formataDate(relatorioAcompanhamento.mesReferencia)}</p>
                            </div>
                            <div className='d-flex flex-column gap-3'>
                                <p className='m-0'><strong>Nº do Instrumento:</strong> {relatorioAcompanhamento.numeroInstrumento}</p>
                                <p className='m-0'><strong>Data da visita:</strong> {formataDate(relatorioAcompanhamento.dataVisita, 'dd/MM/yyyy')}</p>
                            </div>
                            <div className='d-flex flex-column gap-3'>
                                <p className='m-0'><strong>Nº Versão:</strong> {relatorioAcompanhamento.numeroVersao}</p>
                                <p className='m-0'><strong>Status:</strong> {relatorioAcompanhamento.status}</p>
                            </div>
                        </div>

                        <div className='p-3 w-100'>

                            <table className="table borda-padrao table-bordered table-sm text-center">

                                {relatorioAcompanhamento.itensFormulario && relatorioAcompanhamento.itensFormulario.map((bloco) => (
                                    <React.Fragment key={bloco.id}>
                                        <thead>
                                            <tr >
                                                <th
                                                    style={{ 'backgroundColor': '#EDEDED' }}
                                                    className=""
                                                    colSpan={4}
                                                    scope="col"
                                                >
                                                    {bloco.id} - {bloco.blocoDescricao}
                                                </th>
                                            </tr>
                                            <tr>
                                                <th scope="col">Cod</th>
                                                <th scope="col">Pergunta</th>
                                                <th scope="col">Resposta</th>
                                                <th scope="col">Observação</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {bloco.itens && bloco.itens.map((item) => (
                                                <tr key={item.itemId}>
                                                    <td>{item.blocoId}.{item.codPergunta}</td>
                                                    <td className='text-start'>{item.pergunta}</td>
                                                    {modoRetificacao ? (
                                                        <>
                                                            <td>
                                                                <select
                                                                    className="form-select"
                                                                    value={item.respostaId}
                                                                    onChange={(e) =>
                                                                        handleChangeItem(item.itemId, 'respostaId', e.target.value)
                                                                    }
                                                                >
                                                                    {opcoesRespostas.respostas.map((opcao) => (
                                                                        <option
                                                                            key={opcao.id}
                                                                            value={opcao.id}
                                                                        >
                                                                            {opcao.resposta}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </td>
                                                            <td className='text-start'>
                                                                <input
                                                                    className="form-control"
                                                                    value={item.obs || ''}
                                                                    onChange={(e) => handleChangeItem(item.itemId, 'obs', e.target.value)}
                                                                    maxLength={limiteCaracteres.RELAT_ACOMP_OBS_ITEM}
                                                                />
                                                            </td>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <td>{item.resposta}</td>
                                                            <td className='text-start'>{item.obs}</td>
                                                        </>
                                                    )}
                                                </tr>
                                            ))}
                                        </tbody>

                                    </React.Fragment>
                                ))}

                            </table>

                        </div>

                    </div>

                }
            </div>

            <div className='d-flex gap-2'>

                {modoRetificacao ? (

                    <div className='p-3'>

                        <p className='text-danger fs-5 font-kanit'>MODO RETIFICAÇÃO</p>

                        <div className='d-flex gap-3'>

                            <button
                                className="btn btn-secondary"
                                onClick={() => setModoRetificacao(false)}
                            >
                                CANCELAR
                            </button>

                            <button
                                className="btn btn-primary"
                                onClick={() => retificaRelatorioAcompanhamento()}
                            >
                                ENVIAR
                            </button>

                        </div>

                    </div>

                ) : (

                    <div className='p-3'>

                        <p className='text-danger fs-5 font-kanit'>MODO EXIBIÇÃO</p>

                        <div className='d-flex gap-3'>

                            <button
                                className="btn btn-secondary"
                                onClick={() => navigate(-1)}
                            >
                                VOLTAR
                            </button>

                            <button
                                className="btn btn-primary"
                                onClick={() => setShowModalAssinatura(true)}
                            >

                                ASSINATURA
                            </button>

                            <button
                                className="btn btn-primary"
                                onClick={() => setModoRetificacao(true)}
                            >
                                RETIFICAR
                            </button>

                        </div>

                    </div>

                )}

            </div>

        </div >

    );
}

export default VerificaRelatorio
